import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import Sounds from '../Sounds.js';

import "./Popup.css"

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
library.add(faTimes);



class Popup extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showing: this.props.showing,
        }
    }

    hide() {
        if (window.TapticEngine) window.TapticEngine.impact({ style: "medium" });
        Sounds.play('tap');
        this.setState({showing: false});
    }
    show() {
        this.setState({showing: true});
    }

    // Stop propagation of touchmove on mount
    componentDidMount() {
        ReactDOM.findDOMNode(this).addEventListener('touchmove', (e) => {
            e.stopPropagation();
        }, false);
    }



    /*
    * Render
    */

    render() {

        return (
            <div
                className="PopupOverlay"
                style={{
                    pointerEvents: (this.state.showing ? 'auto' : 'none'),
                    willChange: 'opacity',
                    opacity: (this.state.showing ? 1 : 0),
                }}
                onClick={() => {
                    this.hide();
                }}
            >
                <div
                    style={{
                        transform: 'translateY(' + (this.state.showing ? '0' : '-20') + 'px)',
                        willChange: 'transform',
                        transition: 'transform 200ms',
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: '30px',
                            //margin: '30px 0',
                            backgroundColor: '#fff',
                            width: '90%',
                            boxSizing: 'border-box',
                            maxWidth: '520px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            borderRadius: '20px',
                            padding: '50px 20px 35px 20px',
                            boxShadow: '0 0 5px rgba(0,0,0,0.15)',
                        }}
                        onTouchStart={(e) => {
                            e.stopPropagation();
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                cursor: 'pointer',
                                right: '10px',
                                top: '5px',
                                padding: '10px',
                                fontSize: '24px',
                                lineHeight: '1.0',
                            }}
                            /*
                            onTouchStart={(e) => {
                                e.stopPropagation();
                                this.hide();
                            }}
                            */
                            onClick={(e) => {
                                this.hide();
                            }}
                        >
                            <FontAwesomeIcon icon="times" />
                        </div>
                        <div>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Popup;
